import { HttpServerError } from '../http'

/**
 * 将错误转换为json
 */
export const errorToJson = (error: any) => {
  if (error instanceof HttpServerError) {
    return error.toJson()
  }
  return { err: true, message: error?.message }
}
